import React, { useEffect, useState } from 'react';
import Search from './SearchExample';

export default function Timer() {
const [count, setCount] = useState(0);
  const [sec, setSec]    = useState(0);
  const [hour, setHour] = useState(0);
  const [mint, setMint] = useState(0);
  const [button, setButton] = useState("Start");
  const [timerRunning, setTimerRunning] = useState(false);
  const [lap, setLap] = useState([]);

  useEffect(() => {
    let timer;
    if (timerRunning) {
        timer = setInterval(() => {
        setSec((previousSec) => {
          if (previousSec + 1 === 60) {
            if (mint + 1 === 60) {
              setHour((previousHour) => previousHour + 1);
              setMint(0);
            } else {
              setMint((previousMint) => previousMint + 1);
            }
            return 0;
          } else {
            return previousSec + 1;
          }
        });
      }, 1000);
    }

    return () => {
      clearInterval(timer);
    };
  }, [timerRunning, mint]);

  function toggle() {
    if (timerRunning) {
      setButton("Start");
      setTimerRunning(false);
    } else {
      setButton("Stop");
      setTimerRunning(true);
    }
  }

  function reset() {
    setButton("Start");
    setTimerRunning(false);
    setSec(0);
    setMint(0);
    setHour(0);
    setLap((prev) => []);
  }

  function addLap() {
    if (button === "Stop") {
       setCount(count+1);
      setLap((prev) => [...prev, formattedTimer]);
    }
  }

  const formattedTimer = `${hour.toString().padStart(2, '0')}:${mint.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;

  return (
    <>
      <div className="container">
        <h1 className="h1">TIMER</h1>
        <h1 className="h1">{formattedTimer}</h1>
        <button type="button" onClick={toggle}>
          {button}
        </button>
        <button type="button" onClick={reset}>
          Reset
        </button>
        <button type="button" onClick={addLap}>
          Take Lap
        </button>
      </div>
      { lap.length > 0 &&
      <div className="table-div">
        <Search search={lap} count = {count} />
      </div>
      }
    </>
  );
}
